import type { App } from 'vue';
import { setupPinia } from './pinia';
import { setupElementPlus } from './elementPlus';
import { setupI18n } from './i18n';
import { setupAdmApiPlugin } from './api';

/**
 * 注册所有插件
 * @param app Vue应用实例
 */
export function setupPlugins(app: App) {
  // Pinia
  setupPinia(app);

  // Element Plus
  setupElementPlus(app);

  // i18n
  setupI18n(app);

  // API 插件（必须在 Pinia 之后安装，因为 api.ts 中会使用 store）
  setupAdmApiPlugin(app);
}
